export default __webpack_public_path__ + "static/media/oil-change.fd2bd1e8.svg";